// extracted by mini-css-extract-plugin
export default {"thumb":"styles_thumb__V5OPC","track":"styles_track__xaja5","slider":"styles_slider__IL55X","label":"styles_label__Ott5b"};